import { ref } from '../compat/vueCompat';
/**
 * Used to track the number of items injected into the search result from websocket.
 * This value is reset when user performs any search.
 */
export const wsInjectedItemCount = ref<number>(0);

export function updateWsItemInjectionCount(count: number) {
  wsInjectedItemCount.value += count;
}

export function resetWsItemInjectionCount() {
  wsInjectedItemCount.value = 0;
}
